import { useMemo, type FC, type PropsWithChildren } from 'react';

import { IndividualCalendarContext } from '@pages/IndividualCalendar/context/IndividualCalendarContext';

import { useIndividualCalendar, useIndividualCalendarEffects } from '../hooks';

const { Provider } = IndividualCalendarContext;

export const IndividualCalendarProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const {
    todayMoment,
    currentEmployeeId,
    visibleDays,
    visibleColumns,
    periodStartMoment,
    periodEndMoment,
    selectedPeriodTitle,
    isCurrentPeriodSelected,
    returnToTodayHandler,
    goToPrevPeriodHandler,
    goToNextPeriodHandler,
    openEmployeePeriodHandler,
    returnToCurrentPeriodHandler,
    calendarDataRefreshKey,
    refreshCalendarData,
    intervalHeightPx,
    intervalHeightSize,
    gridStepMinutes,
    maxVisibleColumnCount,
    preferredMaxColumns,
    updateGridStepMinutes,
    updateIntervalHeightSize,
    updateMaxVisibleColumnCount,
    updatePreferredMaxColumns,
    previewFields,
    updatePreviewFields,
    updateAvailableGridWidth,
    validatePeriodSearchParamsHandler,
  } = useIndividualCalendar();

  useIndividualCalendarEffects({
    validatePeriodSearchParamsHandler,
  });

  const value = useMemo(
    () => ({
      todayMoment,
      currentEmployeeId,
      visibleDays,
      visibleColumns,
      periodStartMoment,
      periodEndMoment,
      selectedPeriodTitle,
      isCurrentPeriodSelected,
      returnToTodayHandler,
      goToPrevPeriodHandler,
      goToNextPeriodHandler,
      openEmployeePeriodHandler,
      returnToCurrentPeriodHandler,
      calendarDataRefreshKey,
      refreshCalendarData,
      intervalHeightPx,
      intervalHeightSize,
      gridStepMinutes,
      maxVisibleColumnCount,
      preferredMaxColumns,
      updateGridStepMinutes,
      updateIntervalHeightSize,
      updateMaxVisibleColumnCount,
      updatePreferredMaxColumns,
      previewFields,
      updatePreviewFields,
      updateAvailableGridWidth,
    }),
    [
      todayMoment,
      currentEmployeeId,
      visibleDays,
      visibleColumns,
      periodStartMoment,
      periodEndMoment,
      selectedPeriodTitle,
      isCurrentPeriodSelected,
      returnToTodayHandler,
      goToPrevPeriodHandler,
      goToNextPeriodHandler,
      openEmployeePeriodHandler,
      returnToCurrentPeriodHandler,
      calendarDataRefreshKey,
      refreshCalendarData,
      intervalHeightPx,
      intervalHeightSize,
      gridStepMinutes,
      maxVisibleColumnCount,
      preferredMaxColumns,
      updateGridStepMinutes,
      updateIntervalHeightSize,
      updateMaxVisibleColumnCount,
      updatePreferredMaxColumns,
      previewFields,
      updatePreviewFields,
      updateAvailableGridWidth,
    ]
  );

  return <Provider value={value}>{children}</Provider>;
};
